import React, { useEffect } from "react";
import { DynamicTable } from "@workspace/common";
import { useSelector } from "react-redux";
import { Row, Col, Input } from "reactstrap";
import TableItemDisplay from "@workspace/common/src/Components/DynamicTable/TableItemDisplay";
import TableRowsPerPageWithNav from "@workspace/common/src/Components/DynamicTable/TableRowsPerPageWithNav";
import "./DynamicTableWrapper.scss";
import { OFFER_TYPES } from "./constants";

function DynamicTableWrapper({
  data,
  pageInfo,
  pageRequest,
  pageRequestSet,
  config,
  search,
  setSearch,
  optGroup,
  setCustomConfigData,
  header,
  activeRow,
  setActiveRow,
  setTableConfig,
  setIsReportOffcanvasOpen,
  isReportOffcanvasOpen,
  setStatus,
  ...props
}) {
  // Dispatch
  const candidateMeta = useSelector(
    (state) => state.PreOfferCandidateReducer.candidateMeta
  );

  const handleClose = () => {
    setIsReportOffcanvasOpen(false);
  };

  useEffect(() => {
    if (!isReportOffcanvasOpen) {
      pageRequestSet.setPage(0);
      pageRequestSet.setPageSize(50);
    }
  }, [isReportOffcanvasOpen]);

  return (
    <div>
      <Row style={{ borderBottom: "1px solid lightgray" }}>
        <Col lg={12}>
          <div className="d-flex flex-row justify-content-between align-items-center mb-3">
            <div className="d-flex flex-row gap-3 align-items-center justify-content-center ">
              <div className="elc-report-header">{header}</div>
              <div className="search-box">
                {setSearch && (
                  <form onSubmit={pageRequestSet.setSearchTerm}>
                    <input
                      type="text"
                      placeholder="Search.."
                      className="form-control search elc-report-search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="mdi mdi-magnify search-icon"></span>
                  </form>
                )}
              </div>
            </div>
            <div className="d-flex flex-row gap-3 align-items-center justify-content-center ">
              <Input
                type="select"
                className="elc-report-select"
                onChange={(e) => setStatus(e.target.value)}
              >
                {OFFER_TYPES.map((item, index) => (
                  <option key={index} value={item.key}>
                    {item.value}
                  </option>
                ))}
              </Input>
              <TableItemDisplay
                pageInfo={pageInfo}
                isLoading={candidateMeta?.isLoading}
              />
              <div
                style={{
                  width: "2px",
                  height: "20px",
                  backgroundColor: "#adb5bd",
                  marginLeft: "12px",
                }}
              ></div>
              <TableRowsPerPageWithNav
                pageInfo={pageInfo}
                pageRequestSet={pageRequestSet}
              />
              {/* <div>
                <Button className="elc-button-group-single elc-button-group-left">
                  <span className="mdi mdi-notebook-edit-outline"></span>
                </Button>
                <Button className="elc-button-group-single">
                  <span className="mdi mdi-download-outline"></span>
                </Button>
                <Button className="elc-button-group-single elc-button-group-right">
                  <span className="mdi mdi-delete-outline"></span>
                </Button>
              </div> */}
              {/* <Button className="elc-filter">
                <span className="mdi mdi-filter-variant"></span>
              </Button>
              <Button className="elc-create">
                <span className="mdi mdi-plus"></span>
              </Button> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12} className="elc-oc-wrapper">
          <div
            style={{
              height: "calc(100vh - 225px)",
            }}
          >
            <DynamicTable
              config={config}
              data={data}
              pageRequestSet={pageRequestSet}
              pageInfo={pageInfo}
              isLoading={candidateMeta?.isLoading ?? true}
              freezeHeader={true}
              activeRow={activeRow}
              setTableConfig={setTableConfig}
              pageRequest={pageRequest}
              tableHeight="100%"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default DynamicTableWrapper;
